import React from "react";
import { useAuth } from "./auth-routes-provider";
import { useGetCurrentUserApi } from "../api/methods/use-get-current-user-api";
import { useStopImpersonatingApi } from "../api/methods/use-stop-impersonating-api";
import { Button } from "@/components/ui/button";

export const ImpersonateTab: React.FC = () => {
  const auth = useAuth();
  const { data } = useGetCurrentUserApi();
  const stopImpersonating = useStopImpersonatingApi();

  if (auth && data && auth.idTokenPayload.email !== data.attributes.email) {
    return (
      <div className="bg-orange-500 text-white">
        <div className="flex items-center justify-between px-4 h-9">
          <div className="flex-1 text-center text-sm">
            Logged in as {data.attributes.email}
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={stopImpersonating}
            className="text-white hover:bg-orange-600 hover:text-white"
          >
            Stop impersonating
          </Button>
        </div>
      </div>
    );
  }

  return null;
};
